import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
})
export class IconButtonComponent {
  @Input() name: any;
  @Input() typeBtn: string = ''; // Tipo de botón
  @Input() isDisabled = false;
}
